import { Navigate, useParams } from 'react-router-dom'

export const GoHome = () => {
  const { orgID } = useParams()
  if (orgID) return <Navigate replace to={`/${orgID}/organization`} />
  return <Navigate replace to="/" />
}
